import { Specificity } from "../../../specificity.js";
import { WithSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/selectors/#zero-matches}
 */
export class Where extends WithSelector {
    static of(selector) {
        return new Where(selector);
    }
    constructor(selector) {
        super("where", selector, Specificity.of(0, 0, 0));
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context) {
        return this._selector.matches(element, context);
    }
    equals(value) {
        return value instanceof Where && value._selector.equals(this._selector);
    }
    toJSON() {
        return {
            ...super.toJSON(),
        };
    }
}
(function (Where) {
    Where.parse = (parseSelector) => WithSelector.parseWithSelector("where", parseSelector, Where.of);
})(Where || (Where = {}));
//# sourceMappingURL=where.js.map